import { getPaqueteDetalleByIdPaquete, newPaqueteDetalle, updatePaqueteDetalle } from "../services/paqueteDetalleServices";

const dataInicial = {
    paqueteDetalle: {},
    exito: 0
};

const GET_PAQUETES_DETALLE = "GET_PAQUETES_DETALLE";
const POST_PAQUETE_FETALLE_ADD = "POST_PAQUETE_FETALLE_ADD";
const PUT_PAQUETE_DETALLE = "PUT_PAQUETE_DETALLE";
const GET_PAQUETES_DETALLE_CLEAR_STATE = "GET_PAQUETES_DETALLE_CLEAR_STATE";

export default function paqueteDetallleReducer(state = dataInicial, action) {
    switch (action.type) {
        case PUT_PAQUETE_DETALLE:
            return { ...state, exito: action.payload.exito }
        case POST_PAQUETE_FETALLE_ADD:
            return { ...state, exito: action.payload.exito }
        case GET_PAQUETES_DETALLE:
            return { ...state, paqueteDetalle: action.payload.paqueteDetalle };
        case GET_PAQUETES_DETALLE_CLEAR_STATE:
            return {
                ...state,
                paqueteDetalle: action.payload.paqueteDetalle,
                exito: action.payload.exito,
            };
        default:
            return state;
    }
}
export const actulizaPaqueteDetalle = ({ IdPaquete, Incluye, NoIncluye, Itinerario }) => async (dispatch) => {
    return await updatePaqueteDetalle({IdPaquete, Incluye, NoIncluye, Itinerario}).then(Response => {
        dispatch({
            type: PUT_PAQUETE_DETALLE,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const addPaqueteDetalle = ({ IdPaquete, Incluye, NoIncluye, Itinerario }) => async (dispatch) => {
    return await newPaqueteDetalle({IdPaquete, Incluye, NoIncluye, Itinerario}).then(Response => {
        dispatch({
            type: POST_PAQUETE_FETALLE_ADD,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const getPaqueteDetalle = ({ IdPaquete }) => async (dispatch) => {
    return await getPaqueteDetalleByIdPaquete({ IdPaquete }).then(Response => {
        dispatch({
            type: GET_PAQUETES_DETALLE,
            payload: {
                paqueteDetalle: Response
            }
        })
        return Response
    }).catch(Error => {
        return {}
    })
}